import { render, staticRenderFns } from "./pinpad_proxy.vue?vue&type=template&id=0c04ecf4&"
import script from "./pinpad_proxy.vue?vue&type=script&lang=js&"
export * from "./pinpad_proxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports